module.exports = __webpack_public_path__ + "static/img/us-2.41e8c4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/us-2.png
// module id = +8A3
// module chunks = 1